import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '@webapp/utils/localstorage';
import {
  artistProfileCompleted,
  artistProfileUpdated,
} from '@webapp/utils/rudderstack/events';
import SimpleArtist from '@common/types/artist/simple-artist';
import { TracPageSocialLink } from '@services/tracpage/types/track-page-social-link';
import TracPage from '@services/tracpage/types/trac-page';

interface Props {
  artistData: SimpleArtist;
  social?: TracPageSocialLink[];
  artistTracPage?: TracPage;
}

export const updatedArtistSideEffect = async ({
  artistData,
  artistTracPage,
  social,
}: Props) => {
  const isArtistProfileCompleted = getLocalStorageItem(
    'artistProfileCompleted'
  );
  const updateData = {
    artist_id: artistData.id,
    artist_name: artistData.name,
    tracpage_domain: artistData.domain,
    custom_domain: artistTracPage?.subdomain,
    bio: artistData.bio,
    email: artistData.email,
    telephone: artistData.telephone,
    streaming_profiles: artistData.externalIds
      ? Object.keys(artistData.externalIds).map((externalId) => ({
          name: artistData.externalIds
            ? artistData.externalIds[externalId]
            : '',
        }))
      : [],
    social_profiles: social
      ? social.map((social) => ({
          name: social.provider,
          profile_url: social.url,
        }))
      : [],
  };

  if (
    artistData.avatar &&
    artistData.bio &&
    social?.length &&
    !isArtistProfileCompleted
  ) {
    await artistProfileCompleted(updateData);
    setLocalStorageItem('artistProfileCompleted', true);
  } else {
    await artistProfileUpdated(updateData);
  }
};
